import { z } from 'zod';
import { DISCOUNT_TYPES } from '../constants.js';

export const couponValidateSchema = z.object({
  code: z.string().min(1, 'Código obrigatório').max(50),
  subtotal: z.number().nonnegative(),
});

export const couponCreateSchema = z.object({
  code: z
    .string()
    .min(3)
    .max(50)
    .regex(/^[A-Z0-9_-]+$/, 'Código deve conter apenas letras maiúsculas, números, - e _'),
  description: z.string().max(255).nullable().optional(),
  discountType: z.enum(DISCOUNT_TYPES),
  discountValue: z.number().nonnegative(),
  minOrderAmount: z.number().nonnegative().default(0),
  maxUses: z.number().int().positive().nullable().optional(),
  startsAt: z.string().datetime().nullable().optional(),
  expiresAt: z.string().datetime().nullable().optional(),
  isActive: z.boolean().default(true),
});

export const couponUpdateSchema = couponCreateSchema.partial();

export type CouponValidateInput = z.infer<typeof couponValidateSchema>;
export type CouponCreateInput = z.infer<typeof couponCreateSchema>;
export type CouponUpdateInput = z.infer<typeof couponUpdateSchema>;
